/** ColorRect registration: the parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseColorRect } from './parser';
const colorRectRegistration = {
    typeName: 'ColorRect',
    parser: parseColorRect,
};
nodeRegistry.register(colorRectRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map